export function getTermsFromPost(post) {
  if (!post._embedded) return { category: '', tags: [] }
  const { category: categories, post_tag: tags } = post._embedded[
    'wp:term'
  ].reduce((acc, current) => {
    if (current[0]) return { ...acc, [current[0].taxonomy]: current }
    return acc
  }, {})

  return { category: categories[0], tags }
}
